import gql from "graphql-tag";

export default gql`
  query($search: String, $page: Int, $pageSize: Int) {
    fonts: publicFonts(search: $search, page: $page, pageSize: $pageSize) {
      count
      hits {
        id
        family
        variants {
          variant
          file {
            url
          }
        }
        global
      }
    }
  }
`;
